import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
var Icon = function Icon() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "A Filled In Heart"
    }), /*#__PURE__*/_jsx("use", {
      href: "#icon-heart-filled"
    })]
  });
};

export default Icon;